<template>
  <div class="container-cap" id="establishment-dashboard" v-if="surveillance">
    <div v-if="surveillance.year === 2019">
      <establishment-results :surveillance="surveillance">
      </establishment-results>
    </div>
    <div v-else>
      <video-display v-model="showVideo"
                     :source="videoSource">
      </video-display>
      <h2>Espace SPIADI {{ surveillance.year }}</h2>
      <hr>
      <div class="row" >
        <div class="col-lg-10">
          <alert type="warning" class="text-justify">
            <btn size="xs" type="default" @click="helpCollapse = !helpCollapse"
                 class="help-button">
              Aide
            </btn>
            <collapse v-model="helpCollapse">
              <h4>
                Bienvenue sur l'espace SPIADI {{ surveillance.year }} pour
                l'établissement «{{ surveillance.establishment.name }}»
              </h4>
              <p>
                Le menu de navigation situé à gauche
                de l'écran vous permet de vous déplacer entre les différents
                modules de cet espace, ainsi que de changer d'établissement.
              </p>
              <p>
                <span class="text-primary">
                  <span class="glyphicon glyphicon-eject"
                        aria-hidden="true">
                  </span>
                  &nbsp;
                  Changer d'établissement
                </span>
                <br />
                Ce bouton permet d'accéder à l'espace SPIADI
                {{ surveillance.year }} d'un autre établissement ou de revenir
                à la liste des établissements inscrits.
              </p>
              <p>
                <span class="text-primary">
                  <span class="glyphicon glyphicon-cog" aria-hidden="true">
                  </span>
                  &nbsp;
                  Options
                </span>
                <br />
                Ce bouton permet d'accéder au menu des options, qui concernent
                principalement le module de saisie (validation automatique des
                champs et affichage de l'aide lors de la saisie).
              </p>
              <p v-if="isRegistrator">
                <span class="text-primary">
                  <span class="glyphicon glyphicon-list-alt"
                        aria-hidden="true">
                  </span>
                  &nbsp;
                  Fiche Établissement
                </span>
                <br />
                Cette page permet d'éditer la fiche établissement.
              </p>
              <p>
                <span class="text-primary">
                  <span class="text-white glyphicon glyphicon-plus"
                        aria-hidden="true">
                  </span>
                  &nbsp;
                  <span :class="`label label-bactADI`">
                    Module...
                  </span>
                </span>
                <br />
                Un sous-menu est disponible pour chaque module auquel est
                inscrit votre établissement, contenant les pages liées à ce
                module.
              </p>
            </collapse>
          </alert>
          <div>
            <div class="row">
              <div class="col-xs-12">
                <div class="panel panel-default" v-if="denominatorsAvailable">
                  <div class="panel-heading">
                    <div class="panel-title">
                      <h3>
                        Clôture {{year}}
                      </h3>
                    </div>
                  </div>
                  <div class="panel-body">
                    <alert type="warning">
                      <h4 class="help-title">
                        <span class="glyphicon glyphicon-question-sign">
                        </span> Aide
                        <span class="help-navbar">
                          <btn type="default" @click="instructionsCollapse = !instructionsCollapse">
                            Comment valider ma participation ?
                          </btn>
                          <btn type="results" @click="showHelpVideo()" v-if="videoSource != null">
                            <span class="glyphicon glyphicon-film"></span>
                            Visionner l'Actu-SPIADI de clôture
                          </btn>
                        </span>
                      </h4>

                      <collapse v-model="instructionsCollapse">
                        <hr>
                        <p class="text-justify">
                          Les conditions à remplir pour que votre participation au
                          programme SPIADI{{year}} soit validée sont les suivantes :
                          <ul>
                            <li>
                              <strong>
                                Charte d'engagement signée et validée
                              </strong>
                            </li>
                            <li>
                              <strong>
                                Fiche Établissement remplie et validée
                              </strong>
                            </li>
                            <li>
                              <p>
                                <strong>
                                  Pour chaque modalité de surveillance :
                                </strong>
                                <ul>
                                  <li>
                                    <strong>
                                      période de surveillance choisie,
                                    </strong>
                                  </li>
                                  <li>
                                    <strong>
                                      fiches remplies, contrôlées et envoyées,
                                    </strong>
                                  </li>
                                  <li>
                                    <strong>
                                      données d'activité remplies et enregistrées.
                                    </strong>
                                  </li>
                                </ul>
                              </p>
                            </li>
                            <li>
                              <p>
                                Pour l'observation des pratiques
                                <span class="label label-observa4">
                                  {{ observationModulesInfo['observa4'].label }}
                                </span>&nbsp;:
                                <ul>
                                  <li>
                                    <strong>
                                      période de surveillance choisie,
                                    </strong>
                                  </li>
                                  <li>
                                    <strong>
                                      au moins 1 fiche remplie, contrôlée et envoyée.
                                    </strong>
                                  </li>
                                </ul>
                              </p>
                            </li>
                          </ul>
                        </p>
                        <p class="text-justify">
                          <strong>
                            Les encarts «Clôture SPIADI{{year}}» sont accessibles
                            sur l'accueil de chaque modalité.
                          </strong>
                        </p>
                        <p class="text-justify">
                          Une modalité suffit pour la participation à la
                          surveillance, mais seules les modalités dûment
                          complétées seront utilisées dans le rapport national.
                        </p>
                      </collapse>
                    </alert>
                    <div class="recap-container">
                      <div class="recap-panel"
                           v-for="(a, b) in recap"
                           :key="`recap-${b}`">
                        <div :class="`panel panel-${a.style} panel-recap`">
                          <div class="panel-heading text-center">
                            <div class="panel-title">
                              <h4>{{ a.title }}</h4>
                            </div>
                            <span v-if="a.subtitle">{{a.subtitle}}</span>
                          </div>
                          <div class="panel-body">
                            <div v-for="(l, m) in a.checkList"
                                 :key="`${m}-recap-category`"
                                 :class="`alert alert-${l.alertType}`"
                                 role="alert">
                              <p v-if="l.subtitle"
                                 class="text-justify action-panel-subtitle"
                                 v-html="l.subtitle"></p>
                              <ul class="recap-list">
                                <li v-for="(r, k) in l.items" :key="`${k}-recap`">
                                  <span :class="r.classes" aria-hidden="true"></span>
                                  <span v-if="r.closureDate && a.showClosureDates" v-html="`${r.label} le ${r.closureDate}`"></span>
                                  <span v-else v-html="r.label"></span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6" v-if="isCurrentYear">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <div class="panel-title">
                      <h3>Charte d'engagement</h3>
                    </div>
                  </div>
                  <div class="panel-body">
                    <convention :surveillance="surveillance">
                    </convention>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <div class="panel-title">
                      <h3>Fiche établissement</h3>
                    </div>
                  </div>
                  <div class="panel-body" v-if="!denominatorsAvailable">
                    <alert type="warning" class="text-justify">
                      La Fiche Établissement est en cours d'adaptation au
                      protocole {{year}} et sera disponible ultérieurement.
                    </alert>
                  </div>
                  <div class="panel-body" v-else>
                    <alert type="warning" class="text-justify"
                           v-if="estSheetStatus === 'absent'">
                      <p class="text-justify">
                        <strong>
                          La saisie de la
                          <span v-if="isRegistrator">
                            <router-link tag="a" active-class="active"
                                         role="button"
                                         :to="`${routePrefix}/denominators/denominators`">
                              Fiche Établissement
                            </router-link>
                            est ouverte.
                          </span>
                          <span v-else>
                            Fiche Établissement est ouverte. Elle doit être remplie
                            par le référent du programme.
                          </span>
                        </strong>
                      </p>
                      <p class="text-justify">
                        Les données d'activité sont à renseigner en fin de
                        surveillance directement dans les
                        différents modules, en utilisant les encarts
                        «Clôture SPIADI{{year}}».
                      </p>
                    </alert>
                    <alert type="warning" v-else-if="estSheetStatus === 'open'">
                      <p class="text-justify">
                        La Fiche Établissement est en cours de saisie.
                      </p>
                      <p class="text-justify" v-if="isRegistrator">
                        <strong>
                          Une fois la saisie terminée, pensez à valider la fiche
                          à l'aide du bouton ci-dessous.
                        </strong>
                      </p>
                    </alert>
                    <alert type="success" v-else>
                      <p class="text-justify">
                        La fiche Établissement est validée.
                      </p>
                    </alert>
                  </div>
                  <div class="panel-footer"
                       v-if="isRegistrator && estSheetStatus === 'open'">
                    <validate-denominators
                      :surveillance="surveillance"
                      :sheetType="`denominators`">
                    </validate-denominators>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-md-6" v-if="hasToolsUsageSheet">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <div class="panel-title">
                      <h3>Fiche Formation</h3>
                    </div>
                  </div>
                  <div class="panel-body" v-if="!toolsUsageSheetAvailable">
                    <alert type="warning" class="text-justify">
                      La Fiche «Formation» est en cours d'adaptation au
                      protocole {{year}} et sera disponible ultérieurement.
                    </alert>
                  </div>
                  <div class="panel-body" v-else>
                    <alert type="warning" class="text-justify"
                           v-if="toolsUsageSheetStatus === 'absent'">
                      <p class="text-justify">
                        <strong>
                          La saisie de la
                          <span v-if="isRegistrator">
                            <router-link tag="a" active-class="active"
                                         role="button"
                                         :to="`${routePrefix}/denominators/toolsUsage`">
                              Fiche Formation
                            </router-link>
                            est ouverte.
                          </span>
                          <span v-else>
                            Fiche Formation est ouverte. Elle
                            doit être remplie par le référent du programme.
                          </span>
                        </strong>
                      </p>
                    </alert>
                    <alert type="warning" v-else-if="toolsUsageSheetStatus === 'open'">
                      <p class="text-justify">
                        La Fiche Formation est
                        <span v-if="isRegistrator">
                            <router-link tag="a" active-class="active"
                                         role="button"
                                         :to="`${routePrefix}/denominators/toolsUsage`">
                              en cours de saisie.
                            </router-link>
                        </span>
                        <span v-else>
                          en cours de saisie.
                        </span>
                      </p>
                      <p class="text-justify" v-if="isRegistrator">
                        <strong>
                          Une fois la saisie terminée, pensez à valider la fiche
                          à l'aide du bouton ci-dessous.
                        </strong>
                      </p>
                    </alert>
                    <alert type="success" v-else>
                      <p class="text-justify">
                        La Fiche Formation est validée.
                      </p>
                    </alert>
                  </div>
                  <div class="panel-footer"
                       v-if="isRegistrator && toolsUsageSheetStatus === 'open'">
                    <validate-denominators :surveillance="surveillance"
                                           sheetType="toolsUsage">
                    </validate-denominators>
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="col-xs-12 col-md-6">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <div class="panel-title">
                      <h3>Surveillance</h3>
                    </div>
                  </div>
                  <div class="panel-body">
                    <div v-if="surveillanceModules.length > 0">
                      L'établissement est inscrit au.x module.s de surveillance
                      suivants :
                      <div v-for="m in surveillanceModules"
                           :key="`sheet-module-${m}`">
                        <h3>
                          <span :class="`label label-${m}`">
                            {{ surveillanceModulesInfo[m].label }}
                          </span>
                        </h3>
                        <uf-list
                          v-if="surveillance.modules[m].ufs != null"
                          :module="m" :year="year"
                          :ufs="surveillance.modules[m].ufs">
                        </uf-list>
                      </div>
                    </div>
                    <div v-else>
                      <alert type="warning" class="text-justify">
                        <p>
                          <strong>
                            L'établissement n'est actuellement inscrit à aucun
                            module de surveillance.
                          </strong>
                        </p>
                        <p v-if="year === 2022">
                          Pour plus d'informations sur les différents modules et
                          leurs protocoles associés, merci de vous rendre sur
                          <router-link to="/presentation">
                            la page de présentation de la surveillance
                          </router-link>.
                        </p>
                      </alert>
                    </div>
                  </div>
                  <div class="panel-footer" v-if="canEditSurveillance">
                    <btn type="success"
                         @click="editSurveillance(sc.types.surveillance)"
                         block
                         size="lg">
                      Choisir le.s module.s
                    </btn>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-md-6">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <div class="panel-title">
                      <h3>Observation des pratiques</h3>
                    </div>
                  </div>
                  <div class="panel-body">
                    <div v-if="observationModules.length > 0">
                      L'établissement est inscrit au.x module.s d'observation
                      des pratiques suivant.s :
                      <div v-for="m in observationModules"
                           :key="`observation-module-${m}`">
                        <div v-if="m === 'reaSink'">
                          <h3>
                            <span :class="`label label-${m}`">
                              {{ observationModulesInfo[m].label }}
                            </span>
                          </h3>
                          <p class="txt-reaSink">
                            <strong>
                              {{ surveillance.modules[m].uf.name }}
                            </strong>
                            <small>
                              ({{ units[year].findFromIndex(surveillance.modules[m].uf.ufType).code }})
                            </small>
                          </p>
                          <div v-if="surveillance.modules[m].status.val === 0">
                            <alert type="danger">
                              <p>
                                <strong>
                                  <span class="glyphicon glyphicon-alert"
                                        aria-hidden="true">
                                  </span>
                                  En attente des coordonnées d'envoi des
                                  écouvillons
                                </strong>
                              </p>
                              <p>
                                <router-link :to="`${routePrefix}/module/reaSink/dashboard`"
                                             v-if="canEditSurveillance"
                                             tag="btn">
                                  Désigner le destinataire des écouvillons
                                </router-link>
                              </p>
                            </alert>
                          </div>
                          <div v-else-if="surveillance.modules[m].status.val === 1">
                            <alert type="info">
                              <strong>
                                Écouvillons en préparation...
                              </strong>
                            </alert>
                          </div>
                          <div v-else-if="surveillance.modules[m].status.val === 2">
                            <alert type="success">
                              <p>
                                <strong>
                                  Écouvillons envoyés !
                                </strong>
                              </p>
                              <router-link :to="`${routePrefix}/module/reaSink/dashboard`"
                                             v-if="canEditSurveillance"
                                             tag="btn">
                                J'ai reçu les écouvillons
                              </router-link>
                            </alert>
                          </div>
                          <div v-else-if="surveillance.modules[m].status.val === 3">
                            <alert type="warning">
                              <p>
                                <strong>
                                  En attente des prélèvements...
                                </strong>
                              </p>
                              <router-link :to="`${routePrefix}/module/reaSink/dashboard`"
                                             v-if="canEditSurveillance"
                                             tag="btn">
                                En savoir plus
                              </router-link>
                            </alert>
                          </div>
                          <div v-else-if="surveillance.modules[m].status.val === 4">
                            <alert type="info">
                              <p>
                                <strong>
                                  Écouvillons envoyés au laboratoire...
                                </strong>
                              </p>
                            </alert>
                          </div>
                          <div v-else-if="surveillance.modules[m].status.val === 5">
                            <alert type="info">
                              <p>
                                <strong>
                                  Écouvillons en cours d'analyse au laboratoire...
                                </strong>
                              </p>
                            </alert>
                          </div>
                          <div v-else>
                            <alert type="success">
                              <p>
                                <strong>
                                  Enquête terminée, merci pour votre participation.
                                </strong>
                              </p>
                            </alert>
                          </div>
                        </div>
                        <div v-else-if="m === 'reaExplaur'">
                          <h3>
                            <span :class="`label label-${m}`">
                              {{ observationModulesInfo[m].label }}
                            </span>
                          </h3>
                          <div v-if="surveillance.modules[m].srvs != null">
                            <div v-for="(srv, i) in surveillance.modules[m].srvs"
                                 :class="`txt-${m}`"
                                 :key="`sheet-module-${m}-uf-${i}`">
                              <strong>{{ srv.uf.name }}</strong>
                              <small>
                                ({{ units[year].findFromIndex(srv.uf.ufType).code }})
                              </small>
                            </div>
                          </div>
                          <div v-if="surveillance.modules[m].stat.val === 0">
                            <alert type="danger">
                              <p>
                                <strong>
                                  <span class="glyphicon glyphicon-alert"
                                        aria-hidden="true">
                                  </span>
                                  En attente des coordonnées d'envoi des
                                  écouvillons.
                                </strong>
                              </p>
                              <p>
                                <router-link :to="`${routePrefix}/module/reaExplaur/dashboard`"
                                             v-if="canEditSurveillance"
                                             tag="btn">
                                  Désigner le destinataire des écouvillons
                                </router-link>
                              </p>
                            </alert>
                          </div>
                          <div v-else-if="surveillance.modules[m].stat.val === 1">
                            <alert type="info">
                              <p>Écouvillons en préparation...</p>
                            </alert>
                          </div>
                          <div v-else-if="surveillance.modules[m].stat.val === 2">
                            <alert type="success">
                              <p>
                                <strong>
                                  Écouvillons envoyés !
                                </strong>
                              </p>
                              <router-link :to="`${routePrefix}/module/reaExplaur/dashboard`"
                                             v-if="canEditSurveillance"
                                             tag="btn">
                                J'ai reçu les écouvillons
                              </router-link>
                            </alert>
                          </div>
                          <div v-else-if="surveillance.modules[m].stat.val === 3">
                            <alert type="warning">
                              <p>
                                <strong>
                                  Enquête en cours...
                                </strong>
                              </p>
                            </alert>
                          </div>
                        </div>
                        <div v-else>
                          <h3>
                            <span :class="`label label-${m}`">
                              {{ observationModulesInfo[m].label }}
                            </span>
                          </h3>
                        </div>

                      </div>
                    </div>
                    <div v-else>
                      <alert type="warning" class="text-justify">
                        <p>
                          <strong>
                            L'établissement n'est actuellement inscrit à aucun
                            module d'observation des pratiques.
                          </strong>
                        </p>
                        <p v-if="year === 2022">
                          Pour plus d'informations sur les différents modules et
                          leurs protocoles associés, merci de vous rendre sur
                          <router-link to="/observation">
                            la page de présentation de l'observation des
                            pratiques
                          </router-link>.
                        </p>
                      </alert>
                    </div>
                  </div>
                  <div class="panel-footer" v-if="canEditSurveillance">
                    <btn type="success"
                         @click="editSurveillance(sc.types.observation)"
                         block
                         size="lg">
                      Choisir le.s module.s
                    </btn>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-md-6" v-if="hasCauseAnalysisModulesInfo">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <div class="panel-title">
                      <h3>Analyse de Cause</h3>
                    </div>
                  </div>
                  <div class="panel-body">
                    <div v-if="causeAnalysisModules.length > 0">
                      L'établissement est inscrit au.x module.s d'analyse de
                      cause suivants :
                      <div v-for="m in causeAnalysisModules"
                           :key="`sheet-module-${m}`">
                        <h3>
                          <span :class="`label label-${m}`">
                            {{ causeAnalysisModulesInfo[m].label }}
                          </span>
                        </h3>
                        <div v-if="surveillance.modules[m].ufs != null">
                          <div v-for="(uf, i) in surveillance.modules[m].ufs"
                               :class="`txt-${m}`"
                               :key="`sheet-module-${m}-uf-${i}`">
                            <strong>{{ uf.name }}</strong>
                            <small>
                              ({{ units[year].findFromIndex(uf.ufType).code }})
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <alert type="warning" class="text-justify">
                        <p>
                          <strong>
                            L'établissement n'est actuellement inscrit à aucun
                            module d'analyse de cause.
                          </strong>
                        </p>
                      </alert>
                    </div>
                  </div>
                  <div class="panel-footer" v-if="canEditSurveillance">
                    <btn type="success"
                         @click="editSurveillance(sc.types.causeAnalysis)"
                         block
                         size="lg">
                      Choisir le.s module.s
                    </btn>
                  </div>
                </div>
              </div>

              <div class="clearfix" v-if="hasResearchModuleInfo"></div>
              <div class="col-xs-12 col-md-6" v-if="hasResearchModuleInfo">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <div class="panel-title">
                      <h3>Recherche</h3>
                    </div>
                  </div>
                  <div class="panel-body">
                    <div v-if="researchModules.length > 0">
                      L'établissement est inscrit au.x module.s de recherche
                      suivants :
                      <div v-for="m in researchModules"
                           :key="`sheet-module-${m}`">
                        <h3>
                          <span :class="`label label-${m}`">
                            {{ researchModulesInfo[m].label }}
                          </span>
                        </h3>
                        <uf-list
                          v-if="surveillance.modules[m].ufs != null"
                          :module="m" :year="year"
                          :ufs="surveillance.modules[m].ufs">
                        </uf-list>
                      </div>
                    </div>
                    <div v-else>
                      <alert type="warning" class="text-justify">
                        <p>
                          <strong>
                            L'établissement n'est actuellement inscrit à aucun
                            module de recherche.
                          </strong>
                        </p>
                      </alert>
                    </div>
                  </div>
                  <div class="panel-footer" v-if="canEditSurveillance">
                    <btn type="success"
                         @click="editSurveillance(sc.types.research)"
                         block
                         size="lg">
                      Choisir le.s module.s
                    </btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <sui-establishment-edit v-model="editModal"
                            v-if="modules && canEditSurveillance"
                            :surveillance="surveillance"
                            :moduleList="modules"
                            event="surveillances/edit">
    </sui-establishment-edit>
  </div>
</template>
<script>
import establishmentResults from '@/components/establishments/dashboard/results'
import suiEstablishmentEdit from '@/sui/components/establishment/edit'
import validateDenominators from '@/components/sheet/validate/denominators'
import denominators from '@/sui/data/sheets/edit/denominators'
import toolsUsage from '@/sui/data/sheets/edit/toolsUsage'
import modules from '@/sui/data/modules'
import units from '@/sui/data/units'
import ufList from '@/views/establishments/uflist'
import videoDisplay from '@/components/help/videodisplay'
import { mapGetters, mapState } from 'vuex'

import convention from '@/components/establishments/convention'
import impl from '@/views/establishments/impl/dashboard.js'
import go from '@/gojs/go'

export default {
  name: 'establishment-dashboard',

  props: {
    surveillance: {
      type: Object
    }
  },

  data: function () {
    return {
      helpCollapse: false,
      instructionsCollapse: false,
      editModal: false,
      modules: null,
      sc: modules,
      showVideo: false
    }
  },

  methods: {
    editSurveillance: function (type) {
      let target = null
      switch (type) {
        case modules.types.surveillance:
          target = this.surveillanceModulesInfo
          break

        case modules.types.observation:
          target = this.observationModulesInfo
          break

        case modules.types.research:
          target = this.researchModulesInfo
          break

        case modules.types.causeAnalysis:
          target = this.causeAnalysisModulesInfo
          break
      }

      if (target == null) {
        return
      }
      this.modules = target
      this.editModal = true
    },

    showHelpVideo: function () {
      this.showVideo = true
    }
  },

  computed: {
    ...mapState({
      all: state => state.sheet.all,
      available: state => state.sheet.available
    }),

    ...mapGetters({
      userId: 'user/id',
      getActu: 'cloud/getActu'
    }),

    videoSource: function () {
      const byYear = {
        '2026': { month: 'june', date: '18/06/2026' },
        '2025': { month: 'june', date: '12/06/2025' },
        '2024': { month: 'june', date: '20/06/2024' }
      }

      const actu = byYear[this.year]
      if (actu == null) {
        return null
      }

      return this.getActu(this.year, actu.month, actu.date)
    },

    isCurrentYear: function () {
      return `${go.date.currentYear}` === this.year
    },

    closureDeadLine: function () {
      return ` 31 juillet ${this.year}`
    },

    recap: function () {
      const result = []
      if (this.isCurrentYear) {
        result.push(impl.getCvtRecap(this.surveillance.cvt, this.closureDeadLine))
      }

      const validEstbSheet = this.surveillance.establishment.shst === 'valid'

      result.push(impl.getEstablishmentRecap(
        validEstbSheet, this.isCurrentYear, this.closureDeadLine
      ))

      if (this.hasToolsUsageSheet) {
        result.push(
          impl.getFormationRecap(
            this.surveillance.toolsUsage.shst === 'valid',
            this.isCurrentYear, this.closureDeadLine
          )
        )
      }

      const name = `SPIADI${this.year}`
      const moduleNames = this.surveillanceModules
      if (moduleNames.length !== 0) {
        result.push(
          impl.getSurveillanceRecap(
            name, moduleNames, this.surveillanceModulesInfo,
            this.surveillance.modules, this.isCurrentYear,
            this.closureDeadLine, validEstbSheet
          )
        )
      }

      const obsModules = this.observationModules
      if (obsModules.length !== 0) {
        result.push(
          impl.getObservationRecap(
            name, obsModules, this.observationModulesInfo,
            this.surveillance.modules, this.isCurrentYear, this.closureDeadLine,
            validEstbSheet, this.requireEstbSheet
          )
        )
      }

      const causeModules = this.causeAnalysisModules
      if (causeModules.length !== 0) {
        result.push(
          impl.getCauseAnalysisRecap(
            name, causeModules, this.causeAnalysisModulesInfo,
            this.surveillance.modules, this.isCurrentYear, this.closureDeadLine,
            validEstbSheet, this.requireEstbSheet
          )
        )
      }

      return result
    },

    observationModulesInfo: function () {
      return modules.get(
        this.surveillance.year, (m) => m.sheets && m.type === modules.types.observation
      )
    },

    surveillanceModulesInfo: function () {
      return modules.get(
        this.surveillance.year, (m) => m.sheets && m.type === modules.types.surveillance
      )
    },

    researchModulesInfo: function () {
      return modules.get(
        this.surveillance.year,
        (m) => m.sheets && m.type === modules.types.research
      )
    },

    hasResearchModuleInfo: function () {
      return Object.keys(this.researchModulesInfo).length > 0
    },

    causeAnalysisModulesInfo: function () {
      return modules.get(
        this.surveillance.year,
        (m) => m.sheets && m.type === modules.types.causeAnalysis
      )
    },

    hasCauseAnalysisModulesInfo: function () {
      return Object.keys(this.causeAnalysisModulesInfo).length > 0
    },

    units: function () {
      return units
    },

    estSheetStatus: function () {
      return this.surveillance.establishment.shst
    },

    isYear2026OrMore: function () {
      return this.year >= 2026
    },

    hasToolsUsageSheet: function () {
      return this.isYear2026OrMore
    },

    requireEstbSheet: function () {
      return this.isYear2026OrMore
    },

    toolsUsageSheetStatus: function () {
      if (this.hasToolsUsageSheet) {
        return this.surveillance.toolsUsage.shst
      }
      return null
    },

    surveillanceModules: function () {
      return this.surveillance.allSurveillanceModules
    },

    observationModules: function () {
      return this.surveillance.allObservationModules
    },

    researchModules: function () {
      return this.surveillance.allResearchModules
    },

    causeAnalysisModules: function () {
      return this.surveillance.allCauseAnalysisModules
    },

    canEditSurveillance: function () {
      return this.surveillance.isRegistrator(this.userId)
    },

    year: function () {
      return this.$route.params.year
    },

    routePrefix: function () {
      return `/establishments/${this.year}/${this.surveillance.id}`
    },

    isRegistrator: function () {
      return this.surveillance.isRegistrator(this.userId)
    },

    denominatorsAvailable: function () {
      return denominators[this.year] != null
    },

    toolsUsageSheetAvailable: function () {
      return toolsUsage[this.year] != null
    }
  },

  watch: {
  },

  mounted: function () {
  },

  components: {
    'sui-establishment-edit': suiEstablishmentEdit,
    'establishment-results': establishmentResults,
    'convention': convention,
    'validate-denominators': validateDenominators,
    'video-display': videoDisplay,
    'uf-list': ufList
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#establishment-dashboard {
  .panel-recap {
    .alert-light {
      padding: 0px;
    }

    .action-panel-subtitle {
      padding-bottom: 5px;
    }
  }

  .help-title {
    margin-bottom: 0rem;
  }

  .help-navbar {
    margin-left: 1rem;
    .btn {
      margin-left: 1rem;
    }

    .btn:first-child {
      margin-left: 0rem;
    }
  }

  .panel-title h3 {
    margin-top: 0rem;
    margin-bottom: 0rem;
  }

  .panel-title h4 {
    margin-top: 0rem;
    margin-bottom: 0rem;
  }

  .panel-danger {
    .panel-title h4 {
      color: white;
    }
  }

  .alert:last-child {
    margin-bottom: 0rem;
  }

  .alert {
    h3:first-child {
      margin-top: 0rem;
    }
  }
  .help-button {
    float: left;
    margin-top: -2.5rem;
  }

  .recap-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2%;

    .recap-panel {
      flex-basis: 49%;
      @media (min-width: 0) and (max-width: @screen-sm-min) {
        flex-basis: 100%;
      }

      @media (min-width: @screen-lg-min) {
        flex-basis: 32%;
      }

      .panel {
        height: 100%;
        margin-bottom: 0px;
      }

      margin-bottom: 2rem;
    }
  }

  .recap-list {
    list-style-type: none;
    padding: 0;
    .glyphicon {
      margin-right: 0.6rem;
    }
  }
}
</style>
